import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ok-modal',
  templateUrl: './ok-modal.component.html'
})
export class OkModalComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() reason: string;

  constructor(
    public activeModal: NgbActiveModal,
    public tranlsate: TranslateService
  ) { }

  modalTimer: any = localStorage.getItem('modalTimer');
  interval: any;

  ngOnInit() {
    if(this.reason){
      this.message = this.tranlsate.instant(this.message) + this.reason;
    }
    this.modalTimer = this.modalTimer == null ? 300000 : this.modalTimer;
    this.interval = setInterval(()=> { this.activeModal.close(false); clearInterval(this.interval) }, this.modalTimer)
  }
}
